import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppSettings } from '../../utils/app.settings';
import { Observable } from 'rxjs';
import {
  IExitPointsAdjustmentHistory,
  IExitPointsAdjustmentHistoryRequest,
} from '../../interfaces/exit-points-adjustment-history.interface';

@Injectable({
  providedIn: 'root',
})
export class ExitPointsAdjustmentHistoryService {
  constructor(
    private httpClient: HttpClient,
    private appSetting: AppSettings
  ) {}

  getExitPointsAdjustmentHistory(
    payload: IExitPointsAdjustmentHistoryRequest
  ): Observable<IExitPointsAdjustmentHistory[]> {
    const url = `${this.appSetting.exitPointsAdjustmentHistory.urls.base}?puntoSalidaUuid=${payload.puntoSalidaUuid}&fecha=${payload.fecha}${payload.filters ? `&${payload.filters}` : ''}`;
    return this.httpClient.get<IExitPointsAdjustmentHistory[]>(url);
  }
}

